export class ContextOutOfBoundsError extends Error {
  constructor(contextName: string) {
    const msg = `Context "${contextName}" consumed outside of provider`;
    super(msg);
  }
}
